<template>
  <div>
    <navigationBar />
    <fullPage>
      <div class="section section1">
        <img
          class="section-bg"
          src="@/assets/image/index-bg.png"
        />
        <img
          class="section-deco"
          src="@/assets/image/index-deco.png"
          alt=""
        />
        <div class="hero-title">
          <div class="hero-line1">
            建设网站，从<span class="hl">域名注册<img
                class="hero-tip"
                src="@/assets/image/index-tip.png"
                alt="这里注册"
              /></span>开始
          </div>
          <div class="hero-line2">
            <span class="hl">40元</span>抢CN，先订先得，无需竞价
          </div>
        </div>
        <div class="search-row-wrapper">
          <div class="search-domain-warrp">
            <div class="name">域名名称</div>
            <Input
              class="height64"
              v-model.trim="name"
              clearable
              placeholder="请输入域名：如baidu.com"
            />
          </div>
          <div class="search-domainSuffix-warrp">
            <div class="name">域名后缀</div>
            <Select
              class="height64 bg-color-3a3c46 index-select"
              v-model="sufList"
              filterable
              multiple
              placement="bottom"
            >
              <Option
                v-for="item in domainSuffix"
                :value="item.domainSufName"
                :key="item.domainSufName"
                >{{ item.domainSufName }}</Option
              >
            </Select>
          </div>
          <Button
            class="search-btn"
            type="info"
            icon="ios-search"
            @click="search"
            >查询</Button
          >
        </div>
      </div>
      <div class="section auto" v-if="activeShow">
        <div class="section2">
          <div class="section-title">
            <img
              class="icon"
              src="@/assets/image/index-title-icon.png"
            />{{ activeList.title }}
          </div>
          <div class="active-wrap">
           <img class="activeImg" :src="activeList.imgUrl" alt="">
           <div class="active-text">
              <div class="c-5 f-14">{{ activeList.linkUrl }}</div>
          </div>
        </div>
        </div>
      </div>
      <div class="section auto">
        <div class="section2">
          <div class="section-title">
            <img
              class="icon"
              src="@/assets/image/index-title-icon.png"
            />域名注册，从这里开始
          </div>
          <div class="section-panl-warrp">
            <div class="section-panl-item">
              <div class="section-panl-item-icon">
                <img class="icon" src="@/assets/image/index-title-01.png" />
              </div>
              <div class="section-panl-item-title">域名注册</div>
              <div class="section-panl-item-sub">
                <div>首页注册有优惠，首页注册</div>
                <div>有优惠首页注册有优惠</div>
              </div>
              <div style="text-align: center">
                <Button class="section-panl-item-more" @click="to"
                  >查看更多</Button
                >
              </div>
            </div>
            <div class="section-panl-item">
              <div class="section-panl-item-icon">
                <img class="icon" src="@/assets/image/index-title-02.png" />
              </div>
              <div class="section-panl-item-title">续费价格</div>
              <div class="section-panl-item-sub">
                <div>首页注册有优惠，首页注册</div>
                <div>有优惠首页注册有优惠</div>
              </div>
              <div style="text-align: center">
                <Button class="section-panl-item-more" @click="to"
                  >查看更多</Button
                >
              </div>
            </div>
            <div class="section-panl-item">
              <div class="section-panl-item-icon">
                <img class="icon" src="@/assets/image/index-title-03.png" />
              </div>
              <div class="section-panl-item-title">转入价格</div>
              <div class="section-panl-item-sub">
                <div>首页注册有优惠，首页注册</div>
                <div>有优惠首页注册有优惠</div>
              </div>
              <div style="text-align: center">
                <Button class="section-panl-item-more" @click="to"
                  >查看更多</Button
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section auto">
        <div class="section-list">
          <div class="section-title">
            丰富的<img
              class="icon"
              src="@/assets/image/index-title-icon.png"
            />域名种类供您选择
          </div>
          <div class="table">
            <Table
              class="bg-color-242631 bg-table-title"
              :columns="columns"
              :data="priceObj.priceList0"
            >
            </Table>
          </div>
          <div class="to-more" @click="to">
            <div class="title">查看更多</div>
            <img class="icon" src="@/assets/image/more-icon.png" />
          </div>

          <div class="warning-section">
            <p class="warning-title">注意事项：</p>
            <div>
              <div class="text">1、注册域名请先阅读：
                <span @click="RulesModelShow = true" style="cursor:pointer">《智慧康域名注册服务协议》</span>、
                <span @click="renewServiceModelShow = true" style="cursor:pointer">《智慧康域名续费服务协议》</span>
<!--                <span @click="templateServiceModelShow = true" style="cursor:pointer">《智慧康域名模板服务协议》</span>-->
                </div>
              <div class="text">2、CN域名注册后要经过CNNIC审核，如果审核不通过，则域名注册会被退回。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="foot-section">
          <footBar :isBorder="false" />
        </div>
      </div>
    </fullPage>
    <!-- 模态框 -->
    <!-- <commonModal :show.sync="commonVisibility" isHideFooter :styles="{ maxHeight:'300px', overflow: 'auto'}">
      <div class="modal-header" slot="header">添加个人认证</div>
      <div style="height:800px;">11</div>
      <div class="modal-footer" slot="footer">
          <div class="modal-btn-ok">确认</div>
          <div class="modal-btn-cancel">取消</div>
      </div>
    </commonModal> -->
    <!-- 域名注册服务协议 -->
    <rule-modal
      :show.sync="RulesModelShow"
      :content="RulesContent"
      :title="RulesTitle"
    ></rule-modal>
    <!-- 域名续费服务协议 -->
    <rule-modal
      :show.sync="renewServiceModelShow"
      :content="renewServiceContent"
      :title="renewServiceTitle"
    ></rule-modal>
    <rule-modal
        :show.sync="templateServiceModelShow"
        :content="templateServiceContent"
        :title="templateServiceTitle"
    ></rule-modal>
  </div>
</template>
<script>
import templateRules from "@/assets/rule/templateRules";
import navigationBar from "components/navigationBar.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import { getPriceList,getActivity,agreementList } from "api/domain.js";
import ruleModal from "components/ruleModal.vue";
// import commonModal from "components/commonModal/index.vue";
import footBar from "components/footBar.vue";

export default {
  name: "index",
  data() {
    return {
      name: "",
      sufList: [],
      priceObj: {
        priceList0: [],
        priceList1: [],
        priceList2: [],
      },
      columns: [
        {
          width: 400,
          title: "域名后缀",
          key: "name",
          align: "center",
          render: (h, { row }) => {
            return h(
              "div",
              {
                style: {
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      fontSize: "24px",
                      "line-height": "40px",
                      // flex: "0 0 100px",
                    },
                  },
                  row.houzhui
                ),
                h(
                  "span",
                  {
                    style: {
                      flex: "1",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      "-webkit-line-clamp": 1,
                      "-webkit-box-orient": "vertical",
                      fontSize: "18px",
                      "line-height": "40px",
                    },
                  },
                  row.desc
                ),
              ]
            );
          },
        },
        {
          key: "levelName0",
          align: "center",
          renderHeader: (h) => {
            return h("span", "普通会员");
          },
          render: (h, { row }) => {
            if (
              row.priceList != null &&
              row.priceList[0].activityPrice === row.priceList[0].price
            ) {
              return h("span", `${row.priceList[0].activityPrice + '/年' || "-"}`);
            } else if (
              row.priceList != null &&
              row.priceList[0].activityPrice == null
            ) {
              return h("span", `${row.priceList[0].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.priceList != null ? row.priceList[0].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.priceList != null
                  ? row.priceList[0].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName1",
          align: "center",
          renderHeader: (h) => {
            return h("span", "金牌会员");
          },
          render: (h, { row }) => {
            if (
              row.priceList != null &&
              row.priceList[1].activityPrice === row.priceList[1].price
            ) {
              return h("span", `${row.priceList[1].activityPrice + '/年' || "-"}`);
            } else if (
              row.priceList != null &&
              row.priceList[1].activityPrice == null
            ) {
              return h("span", `${row.priceList[1].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.priceList != null ? row.priceList[1].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.priceList != null
                  ? row.priceList[1].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName2",
          align: "center",
          renderHeader: (h) => {
            return h("span", "钻石会员");
          },
          render: (h, { row }) => {
            if (
              row.priceList != null &&
              row.priceList[2].activityPrice === row.priceList[2].price
            ) {
              return h("span", `${row.priceList[2].activityPrice + '/年' || "-"}`);
            } else if (
              row.priceList != null &&
              row.priceList[2].activityPrice == null
            ) {
              return h("span", `${row.priceList[2].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.priceList != null ? row.priceList[2].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.priceList != null
                  ? row.priceList[2].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName3",
          align: "center",
          renderHeader: (h) => {
            return h("span", "皇冠会员");
          },
          render: (h, { row }) => {
            if (
              row.priceList != null &&
              row.priceList[3].activityPrice === row.priceList[3].price
            ) {
              return h(
                "span",
                { style: { fontSize: "14px" } },
                `${row.priceList[3].activityPrice + '/年' || "-"}`
              );
            } else if (
              row.priceList != null &&
              row.priceList[3].activityPrice == null
            ) {
              return h(
                "span",
                { style: { fontSize: "14px" } },
                `${row.priceList[3].price + '/年'}`
              );
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.priceList != null ? row.priceList[3].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.priceList != null
                  ? row.priceList[3].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
      ],
      list: [],
      commonVisibility: false,

      activeShow:true,
      activeList:{},

      RulesModelShow:false,
      RulesContent:'',
      RulesTitle:'',
      renewServiceModelShow: false,
      renewServiceContent: '',
      renewServiceTitle: '',

      templateServiceModelShow: false,
      templateServiceContent: '',
      templateServiceTitle: '',
    };
  },
  components: {
    navigationBar,
    fullPage: () => import("components/fullPage.vue"),
    // commonModal,
    ruleModal,
    footBar,
  },
  computed: {
    ...mapState(["domainQueryData"]),
    domainSuffix() {
      return this.domainQueryData.domainSuffix.length > 0
        ? this.domainQueryData.domainSuffix
        : [];
    },
  },
  async created() {
    if (this.domainQueryData.domainSuffix.length === 0) {
      this.ACT_DOMAIN_QUERY();
    }
    this.req_getPriceList(0);
    this.getActivityList()
    this.getAgreementList()
    // this.req_getPriceList(1);
    // this.req_getPriceList(2);

    this.templateServiceTitle = templateRules.title;
    this.templateServiceContent = templateRules.content;
  },
  methods: {
    ...mapActions(["ACT_DOMAIN_QUERY"]),
    ...mapMutations(["MTU_SEARCH_DATA"]),
    getAgreementList(){
      agreementList([1,2]).then((res) => {
              const { code, data } = res;
              if(code === 200 && data.length>0){
                this.RulesContent = data[0].content
                this.RulesTitle = data[0].name
                this.renewServiceContent = data[1].content
                this.renewServiceTitle = data[1].name
              }
      });
    },
    req_getPriceList(type) {
      getPriceList(type).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.priceObj[`priceList${type}`] = data;
        }
      });
    },
    search() {
      this.MTU_SEARCH_DATA(this.sufList);
      this.$router.push({ path: "/search", query: { name: this.name } });
    },
    to() {
      this.$router.push("/price");
    },
    async getActivityList(){
      const { code, data } = await getActivity()
      if (code == 200) {
        if(data.bannerList.length>0){
           this.activeShow = true
           this.activeList = data.bannerList[0]
        }else{
          this.activeShow = false
        }
      }
    }
  },
};
</script>
<style lang="less" scoped>
/deep/.height64 {
  .ivu-input {
    height: 64px;
    line-height: 64px;
  }
  .ivu-input:hover,
  .ivu-input:focus {
    border-color: @brand;
    box-shadow: none;
  }
  .ivu-input-icon {
    line-height: 64px;
  }
  .ivu-input-with-prefix {
    padding-left: 64px;
  }
  .ivu-input-prefix {
    width: 64px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 64px;
  }
  .ivu-select-input {
    height: 64px;
  }
  .ivu-select-selected-value {
    height: 64px;
    line-height: 64px;
  }
  .ivu-select-placeholder {
    height: 64px;
    line-height: 64px;
  }
  .ivu-input-icon-clear {
    line-height: 64px;
    font-size: 24px;
  }
  .ivu-select-arrow {
    line-height: 64px;
    font-size: 24px;
    color: @brand;
  }
  .ivu-tag {
    line-height: 30px;
    height: 30px;
    color: @brand;
  }
  .ivu-select-item-selected,
  .ivu-select-item-selected:after {
    color: @brand;
  }
  .ivu-select-selection {
    border-color: @brand;
    box-shadow: none;
  }
  .ivu-select-item-selected:after {
    border: 1px solid @brand;
    border-radius: 4px;
  }
}
</style>
<style lang="less" scoped>
.section {
  min-width: 1200px;
  height: 100vh;
  background-color: #F5F7FA;
}
.section1 {
  position: relative;
  .flex(center,center);
  background-color: #FFFFFF;
  .section-bg {
    // 与线上（旧版）一致：等比铺满宽度、垂直居中，不裁切不拉伸
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: auto;
    z-index: 0;
  }
  .section-deco {
    // 旧版深色大图右侧的红蓝波纹装饰，浅色底图缺失，这里补回
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 10.7%;
    height: auto;
    z-index: 0;
    pointer-events: none;
  }
  .hero-title {
    position: absolute;
    top: 36%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    text-align: center;
    white-space: nowrap;
    .hero-line1 {
      font-size: 56px;
      font-weight: bold;
      color: @text-title;
      .hl {
        position: relative;
        color: @danger;
        border-bottom: 3px solid @danger;
        padding-bottom: 4px;
      }
      .hero-tip {
        // 「这里注册 + 弧线箭头」直接取自旧版大图原始美术（index-tip.png），
        // 位置按旧图实测换算：素材左边缘在「域名注册」右端左侧 37px、上方 94px
        position: absolute;
        right: -150px;
        top: -105px;
        width: 188px;
        height: auto;
      }
    }
    .hero-line2 {
      font-size: 40px;
      color: @text-body;
      margin-top: 34px;
      .hl {
        color: @danger;
        font-weight: bold;
      }
    }
  }
  .search-row-wrapper {
    position: absolute;
    width: 1200px;
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    .flex(space-between,center);
    .name {
      font-size: 18px;
      color: @text-title;
      margin-bottom: 21px;
    }
    .search-domain-warrp {
      width: 678px;
    }
    .search-domainSuffix-warrp {
      width: 345px;
    }
    .search-btn {
      align-self: flex-end;
      width: 132px;
      height: 64px;
      font-size: 18px;
    }
  }
}
@media screen and (max-width: 1366px) {
  .section1 {
    .hero-title {
      .hero-line1 {
        font-size: 44px;
      }
      .hero-line2 {
        font-size: 30px;
        margin-top: 26px;
      }
    }
    .section-deco {
      width: 9%;
    }
  }
}
.section2 {
  width: 1200px;
  margin: 0 auto;
  // padding-top: 100px;
  .flex(center, center);
  flex-direction: column;
  .active-wrap{
     width: 1200px;
    .active-text{
      margin-top: 20px;
      line-height: 30px;
      color: @text-body;
   }
    .activeImg{
      width: 1200px;
    }
  }
  .section-title {
    .flex(center, center);
    font-size: 38px;
    color: @text-title;
    font-weight: bold;
    margin: 8% 0 8%;
    // margin: 30px 0 20px;
    .icon {
      width: 34px;
      height: 34px;
      margin-right: 10px;
    }
  }
  .section-panl-warrp {
    .flex(flex-start, flex-start);
    .section-panl-item {
      width: 320px;
      padding: 30px;
      border-radius: 26px;
      cursor: pointer;
      // 与生产环境一致：常态 290px 收起，hover 展开到 370px，
      // 「查看更多」靠 overflow:hidden 自然裁切/露出（线上无 JS、无显隐动画）
      height: 290px;
      overflow: hidden;
      transition: height 0.5s;
      .section-panl-item-icon {
        .flex(center, center);
        .icon {
          width: 115px;
          height: 115px;
        }
      }
      .section-panl-item-title {
        font-size: 24px;
        letter-spacing: 10px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        margin-top: 20px;
      }
      .section-panl-item-sub {
        margin-top: 20px;
        text-align: center;
        font-size: 18px;
        color: #fff;
      }
      .section-panl-item-more {
        width: 130px;
        height: 44px;
        margin-top: 20px;
      }
      &:hover {
        height: 370px;
      }
      &:nth-child(1) {
        background-color: #c4332e;
      }
      &:nth-child(2) {
        background-color: #8f6deb;
        margin: 0 80px;
      }
      &:nth-child(3) {
        background-color: #288DF0;
      }
    }
  }
}

.section-list {
  width: 1200px;
  margin: 0 auto;
  // padding-top: 100px;
  .section-title {
    .flex(center, center);
    font-size: 32px;
    color: @text-title;
    font-weight: bold;
    margin: 5% 0 5%;
    .icon {
      width: 34px;
      height: 34px;
      margin: 0 10px;
    }
  }
}
.warning-section{
  margin-top: 50px;
  .warning-title{
    font-weight: bold;
    font-size: 28px;
    color: @text-title;
    line-height: 48px;
  }
  .text{
    font-size: 18px;
    color: @text-body;
    line-height: 36px;
    span{
      color: @danger;
    }
  }
}
.auto {
  display: flex;
  align-items: center;
}
.section.auto + .section.auto {
  border-top: 1px solid #ECEEF2;
}
.foot-section {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.foot-bar .foot-bar-warp-top {
  border: none;
}
.to-more {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  // 与上方表格拉开距离（线上是 0，这里按诉求留出间距）
  margin-top: 30px;
  .title {
    color: #c4332e;
    font-size: 18px;
  }
  .icon {
    margin-left: 10px;
    width: 44px;
    height: 20px;
  }
}
@media screen and (max-width: 1366px) {
  .section-list {
    padding-top: 60px;
  }
  .section-list .section-title {
    font-size: 24px;
    margin: 20px 0 20px;
  }
}
</style>
